module.exports = __webpack_public_path__ + "img/example-5.3c5a53a1.png";